import { Box } from '@mui/material';
import { PanelResizeHandle } from 'react-resizable-panels';
import { GUTTER_PX, HAIRLINE } from '../chrome';

/** Thickness of the line the grabbed gutter shows, in CSS pixels. */
const HIGHLIGHT_PX = 2;

/**
 * The draggable split between two panes: a gutter that separates them with
 * the ground behind them, without drawing a line of its own, and shows a
 * thin hairline along its middle while it is grabbed. `direction` is the axis the split runs along.
 */
export default function ResizeGutter({
    direction,
}: {
    direction: 'horizontal' | 'vertical';
}) {
    const size = (px: number) =>
        direction === 'horizontal'
            ? { width: `${px}px`, height: '100%' }
            : { width: '100%', height: `${px}px` };
    return (
        <PanelResizeHandle>
            <Box
                sx={{
                    ...size(GUTTER_PX),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    data-testid="resize-gutter-highlight"
                    sx={{
                        ...size(HIGHLIGHT_PX),
                        transition: 'background-color 120ms',
                        // The handle, not this line, carries the state.
                        '[data-resize-handle-state="hover"] &, [data-resize-handle-state="drag"] &':
                            {
                                bgcolor: HAIRLINE,
                            },
                        '@media (prefers-reduced-motion: reduce)': {
                            transition: 'none',
                        },
                    }}
                />
            </Box>
        </PanelResizeHandle>
    );
}
